/* global angular */

export default function($log, $stateParams, $q, ProfileClass, ApiClass) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  const { profile } = ProfileClass.profileComplete;
  const profile_uid = $stateParams.employeeID || profile.profile_uid;

  vm.updateProfile = () => {
    vm.updating = true;
    const userParams = {
      profile_uid: vm.formData.profile_uid,
      first: vm.formData.first,
      last: vm.formData.last,
      firm: vm.formData.firm,
      phone: vm.formData.phone,
      email: vm.formData.email,
      ptin: vm.formData.ptin,
      occupation: vm.formData.occupation,
      address: vm.formData.address,
      state: vm.formData.state,
      zip: vm.formData.zip,
      city: vm.formData.city
    };
    ApiClass.usersIdPatch({ id: profile_uid }, userParams)
      .then(() => {
        vm.profile = angular.copy(vm.formData);
        vm.profileInfo.$setPristine();
        vm.updating = false;
      })
      .catch(error => {
        $log.error({ error });
      });
  };

  vm.updateFormValidation = () => {
    if (vm.profileInfo.$valid) vm.profileInfo.$setPristine();
  };

  vm.reset = () => {
    vm.formData = angular.copy(vm.profile);
    vm.profileInfo.$setPristine();
  };

  function activate() {
    vm.updating = true;

    if (vm.basicInfo) {
      vm.formData = vm.profileData;
      return (vm.updating = false);
    }

    if (vm.profileData && vm.profileData.email) {
      vm.profile = angular.copy(vm.profileData);
      vm.formData = vm.profileData;
      vm.updating = false;
    } else {
      ApiClass.usersIdGet({ id: profile_uid }, {}, {})
        .then(({ data: { item: profile } }) => {
          $log.debug('Profile Component Data Loaded:', profile);
          vm.profile = angular.copy(profile);
          vm.formData = profile;
          vm.updating = false;
        })
        .catch(error => {
          $log.error(error);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/userProfile/controller.js